import { render, staticRenderFns } from "./ak2.vue?vue&type=template&id=9dd0893c"
import script from "./ak2.vue?vue&type=script&lang=js"
export * from "./ak2.vue?vue&type=script&lang=js"
import style0 from "./ak2.vue?vue&type=style&index=0&id=9dd0893c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports